<template>
  <div class="advertManage">
    <OATableOnly :data="data" :columns="columns" @search="handleSearch" :loading="loading"
      @selectionChange="selectionChange" :selection-row="true">
      <div slot="button">
        <OAButton @click="add">添加</OAButton>
        <OAButton @click="edit" class="pull-right" type="warning" :disabled="checkList.length!==1">编辑</OAButton>
        <OAButton @click="remove" class="pull-right" type="danger" :disabled="checkList.length!==1">删除</OAButton>
      </div>
    </OATableOnly>
    <OAModalForm :title="titleText" :visible.sync="dialogVisible" :form-data="formData" @on-submit="submit"
      @on-cancel="dialogVisible = false" labelWidth="140px"></OAModalForm>
  </div>
</template>
<script>
  import OAModalForm from "@/components/OAModalForm/OAModalForm";
  import OAImage from "@/components/OAColums/OAImage";
  import {
    resFilter,
    setValue
  } from "@/common/util.js";
  import commonApi from "@/services/common.js";
  import advertManageApi from "@/services/advertManage.js";
  import moment from "moment";

  export default {
    name: "advertManage",
    components: {
      OAModalForm,
      OAImage
    },
    data() {
      return {
        columns: [{
            title: "主键ID",
            key: "id"
          },
          {
            title: "所属项目",
            key: "projectName"
          },
          {
            title: "应用页面",
            key: "routerName"
          },
          {
            title: "广告图",
            key: "imgList",
            component: {
              name: OAImage
            }
          },
          {
            title: "更新时间",
            key: "createTime"
          }
        ],
        formData: {
          projectName: {
            formType: "a-input",
            value: undefined,
            placeholder: "请输入项目名称",
            label: "所属项目：",
            rules: [{
              required: true,
              message: "请输入项目名称"
            }]
          },
          routerName: {
            formType: "a-input",
            value: undefined,
            placeholder: "请输入页面路由名称",
            label: "应用页面：",
            rules: [{
              required: true,
              message: "请输入页面路由名称"
            }]
          },
          imgList: {
            formType: "sky-upload-img",
            value: [],
            placeholder: "请上传广告图",
            label: "广告图：",
            rules: [{
              required: true,
              message: "请上传广告图"
            }],
            platform: 'oa-pub-oss',
          },
          createTime: {
            formType: "a-span",
            value: undefined,
            label: "更新时间："
          }
        },
        data: [],
        dialogVisible: false,
        loading: false,
        titleText: "",
        checkList: [],
        form: {},
        id: "",
        defaultUrl: "http://oa-public-resource.oss-cn-hangzhou.aliyuncs.com/"
      };
    },
    mounted() {},
    methods: {
      async updateJSON() {
        let res = await advertManageApi.getPageMapping({
          projectName: "oa"
        });
      },
      async handleSearch() {
        this.loading = true;
        let res = await advertManageApi.getGuideList();
        this.data = res.data;
        this.loading = false;
      },
      selectionChange(selection) {
        this.checkList = selection;
      },
      add() {
        this.dialogVisible = true;
        this.titleText = "添加";
        this.formData.createTime.value = moment().format("YYYY-MM-DD hh:mm:ss");
        this.id = "";
      },
      edit() {
        this.dialogVisible = true;
        this.titleText = "修改权限";
        this.form = setValue(this.checkList[0], this.formData);
        this.form.imgList.value = JSON.parse(this.checkList[0].imgList);
        this.id = this.checkList[0].id;
      },
      async submit(val) {
        let res;
        val.imgList.forEach(item => {
          item.url = this.defaultUrl + item.ossName;
        });
        val.imgList = JSON.stringify(val.imgList);
        if (this.id) {
          val["id"] = this.id;
          res = await advertManageApi.updateGuide(val);
        } else {
          res = await advertManageApi.addGuide(val);
        }
        this.dialogVisible = false;
        // this.updateJSON();
        resFilter(res, this.handleSearch());
      },
      remove() {
        this.$confirm("此操作将永久删除, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(async () => {
            let id = this.checkList[0].id;
            let res = await advertManageApi.deleteGuide({
              id: id
            });
            // this.updateJSON();
            resFilter(res, this.handleSearch());
          })
          .catch(() => {});
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/pages/set/advertManage.vue